import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import AppTheme from './theme/AppTheme';
import AppAppBar from './components/AppBar';
import MainContent from './Pages/MainContent';
import Publications from './components/Papers';
import Footer from './components/Footer';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route,useLocation,useNavigate,Navigate } from 'react-router-dom';
import Disclaimer from './Pages/Disclaimer';
import Contact from './Pages/Contact';


export default function App(props: { disableCustomTheme?: boolean }) {
  const [loc,setLoc]=useState<undefined|string>('');

  type Props={setLoc_:(e:any)=>void;}

 const MyRoutes=({setLoc_}:Props)=>{
    var location=useLocation();
    setLoc_(location);
    const path = (/#!(\/.*)$/.exec(location.hash) || [])[1];
    if (path){
      return(
        <Navigate to={path} />
      )
    }
    return (
    <Routes>
          <Route path="/" element={<div><MainContent /> <Publications /></div>}/>
          <Route path="/disclaimer" element={<Disclaimer />}/>
          <Route path="/contact" element={<Contact />}/>
        </Routes>
    )
  }

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
   
      <AppAppBar />
       <BrowserRouter> 
       
      <Container
        maxWidth="lg"
        component="main"
        sx={{ display: 'flex', flexDirection: 'column', my: 16, gap: 4 }}
      > 
        <MyRoutes setLoc_={setLoc}/>
        
        
        
        
      </Container>
      </BrowserRouter>
      <Footer location={loc}/>
    </AppTheme>
  );
}
